import { render, staticRenderFns } from "./UpdateAltCoinXChangeModal.vue?vue&type=template&id=3b9fd472&scoped=true&"
import script from "./UpdateAltCoinXChangeModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAltCoinXChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fd472",
  null
  
)

export default component.exports